module.exports = __webpack_public_path__ + "img/4-3.2e3a4de3.svg";